export const toGetAgentStatisticsQueryParams = (options) => {
    /* eslint-disable-next-line @typescript-eslint/no-explicit-any */
    const params = {};
    for (const [key, val] of Object.entries(options)) {
        switch (key) {
            case 'after':
            case 'before':
                if (val instanceof Date) {
                    params[key] = val === null || val === void 0 ? void 0 : val.toISOString();
                }
                else {
                    params[key] = val;
                }
                break;
            default:
                params[key] = val;
                break;
        }
    }
    return params;
};
